import React from 'react';
import PropTypes from 'prop-types';

function MainLayoutBeforeLogin({ children }) {
  return (
    <div>
      login Header
      {children}
    </div>
  );
}

MainLayoutBeforeLogin.propTypes = {
  children: PropTypes.element.isRequired,
};
export default MainLayoutBeforeLogin;
